import merge from 'lodash/merge';
import clone from 'lodash/clone';
import isMobile from '../lib/isMobile';
import fluxDefaults from './defaults';
// import squareWalls from './partials/squareWalls';
const mobile = isMobile();

module.exports = merge(
    clone(fluxDefaults, true),
    // squareWalls,
    {
    // gravity: 4,
    // particleScale: 0.6,
    // particlesRadius: 0.069,
    // initialTicks: 200,
    // walls: [
    //     // left
    //     // {
    //     //     x: '-5%',
    //     //     y: '-5%',
    //     //     width: 20,
    //     //     height: '110%',
    //     // },
    //     // // right
    //     // {
    //     //     x: '105%',
    //     //     y: '-5%',
    //     //     width: 20,
    //     //     height: '110%',
    //     // },
    //     // // top
    //     // {
    //     //     x: '-5%',
    //     //     y: '-5%',
    //     //     width: '110%',
    //     //     height: 20,
    //     // },
    //     // bottom
    // ],
    walls: [
        // left
        {
            x: '-5%',
            y: '-5%',
            width: '5%',
            height: '105%',
        },
        // right
        {
            x: '100%',
            y: '-5%',
            width: '5%',
            height: '105%',
        },
        // top
        {
            x: '0%',
            y: '-5%',
            width: '105%',
            height: '5%',
        },
        // bottom
        {
            x: '-5%',
            y: '85%',
            width: '110%',
            height: 20,
        },
    ],
    // movingWalls: [
    //
    // ],
    blobs: [
        // main blobs
        {
            x: '0%',
            y: '50%',
            width: '100%',
            height: mobile ? '8%' : '8%',
            color: [0, 0, 0, 255],
        },
        {
            x: '0%',
            y: '60%',
            width: '100%',
            height: mobile ? '1%' : '1%',
            color: [255, 0, 0, 255],
        },
        {
            x: '0%',
            y: '65%',
            width: '100%',
            height: mobile ? '1%' : '1%',
            color: [0, 255, 0, 255],
        },
        {
            x: '0%',
            y: '70%',
            width: '100%',
            height: mobile ? '1%' : '1%',
            color: [0, 0, 255, 255],
        },
    ],
});



// WEBPACK FOOTER //
// ./js/flux/familyPump.js